<script setup lang="ts">

import { formatNumber, formatShort } from '@/models/formatNumber.ts'

defineProps({
  amount: {
    type: Number,
    required: true
  },
  allowZero: {
    type: Boolean,
    default: true
  },
  fractions: {
    type: Boolean,
    default: false
  },
  shortFormat: {
    type: Boolean,
    default: true
  }
})

</script>

<template>

  <span v-if="amount < 0" class="text-red-500">
    {{ shortFormat ? formatShort(amount) : formatNumber(amount) }}
  </span>
  <span v-else-if="amount > 0" class="text-green-500">
    <span v-if="amount === 666666">?</span><span v-else>
    {{ shortFormat ? formatShort(amount) : formatNumber(amount) }}
  </span>
  </span>
  <span v-else-if="allowZero" class="text-gray-500">
    0
  </span>
</template>

<style scoped lang="scss">

</style>